import { useState, useEffect } from 'react';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!visible) return null;

  return (
    <button
      onClick={scrollTop}
      className="fixed bottom-8 right-6 z-50 w-10 h-10 flex items-center justify-center bg-violet-600 hover:bg-violet-700 text-white rounded-full shadow-lg cursor-pointer transition-all hover:scale-110 active:scale-95 whitespace-nowrap"
      aria-label="回到顶部"
      style={{ animation: 'fadeInUp 0.25s ease' }}
    >
      <i className="ri-arrow-up-line text-base" />
    </button>
  );
};

export default BackToTop;
